module.exports = __webpack_public_path__ + "static/img/shenqinrenhzeng.fd7006b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shenqinrenhzeng.png
// module id = rZU2
// module chunks = 18